import React from 'react';

const LeagueSelector = ({ leagues, selectedLeague, onSelect, loading }) => {
  if (loading) {
    return (
      <div className="flex gap-2 overflow-x-auto pb-2">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-10 w-32 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse flex-shrink-0"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {leagues.map((league) => (
        <button
          key={league.key}
          onClick={() => onSelect(league.key)}
          className={`px-4 py-2 rounded-lg font-medium text-sm transition-all ${
            selectedLeague === league.key
              ? 'bg-green-600 text-white shadow-lg'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 shadow'
          }`}
        >
          {league.title}
        </button>
      ))}
    </div>
  );
};

export default LeagueSelector;
